const initialState = {
  vettings: [],
  fetchingVettings: false,
  errorFetchingVettings: null,
  totalPages: 1,
  totalCount: 0,
  size: 10,

  errorCreatingVetting: null,
  creatingVetting: false,
};

export default initialState;
